import ContextProvider from 'common/contexts/crud';
import useRouter from 'common/hooks/use-router';
import PropTypes from 'prop-types';
import React, {
  // eslint-disable-next-line comma-dangle
  createContext, useCallback, useContext, useMemo
} from 'react';
import createPersistedState from 'use-persisted-state';

const CompaniesContext = createContext();
const usePersistedState = createPersistedState('currentCompany');

export const CompaniesProvider = ({ children }, props) => {
  const [currentCompany, setCurrentCompany] = usePersistedState(null);
  const router = useRouter();
  const selectCurrentCompany = useCallback((company) => {
    setCurrentCompany(company);
    router.push('/');
  }, [setCurrentCompany, router]);

  const value = useMemo(() => ({
    currentCompany,
    selectCurrentCompany,
    setCurrentCompany,
  }), [
    currentCompany,
    selectCurrentCompany,
    setCurrentCompany,
  ]);

  return (
    <ContextProvider
      url="companies"
      value={value}
      context={CompaniesContext}
      {...props}
    >
      {children}
    </ContextProvider>
  );
};

CompaniesProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

const useCompanies = () => useContext(CompaniesContext);

export default useCompanies;
